import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";
import { Boxes } from "lucide-react";

function ModuleProgression({ progress }) {
  return (
    <Box
      sx={{
        position: "relative",
        width: 72,
        height: 72,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Cercle de progression */}
      <CircularProgress
        variant="determinate"
        value={progress || 0}
        size={60}
        thickness={4}
        sx={{
          color: "#28a745", // Couleur de succès Bootstrap
          position: "absolute",
        }}
      />

      {/* Fond bleu avec icône */}
      <div
        className="bg-primary bg-gradient rounded-circle d-flex align-items-center justify-content-center"
        style={{
          width: 50, // 72% du container parent
          height: 50, // 72% du container parent
          position: "absolute",
        }}
      >
        <Boxes size={28} color="#fff" />
      </div>

      {/* Pourcentage */}
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          bottom: -16,
          fontSize: "0.75rem",
          fontWeight: "bold",
        }}
      >
        {Math.round(progress || 0)}%
      </Typography>
    </Box>
  );
}

export default ModuleProgression;
